import { useState, useEffect, useCallback } from "react";
import {
  isGameSoundMuted,
  setGameSoundMuted,
  toggleGameSoundMuted,
  subscribeGameSoundMute,
} from "../utils/gameAudio";

export function useGameSoundMute() {
  const [muted, setMuted] = useState(() => isGameSoundMuted());

  useEffect(() => subscribeGameSoundMute(setMuted), []);

  const toggleMute = useCallback(() => {
    toggleGameSoundMuted();
  }, []);

  const setMutedPreference = useCallback((value) => {
    setGameSoundMuted(!!value);
  }, []);

  return {
    muted,
    toggleMute,
    setMuted: setMutedPreference,
  };
}

export default useGameSoundMute;
